import * as Yup from 'yup';

const serviceVendorSchema = Yup.object().shape({
  name: Yup.string().required('Name is required.'),
  extraMobile1: Yup.string().required('Phone number 1 is required.'),
});

export default serviceVendorSchema;
